import { render, staticRenderFns } from "./TongLi.vue?vue&type=template&id=ca70cf52&scoped=true&"
import script from "./TongLi.vue?vue&type=script&lang=js&"
export * from "./TongLi.vue?vue&type=script&lang=js&"
import style0 from "./TongLi.vue?vue&type=style&index=0&id=ca70cf52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca70cf52",
  null
  
)

export default component.exports